import { render, staticRenderFns } from "./PopinEditorialContent.vue?vue&type=template&id=7e08a6ca&"
import script from "./PopinEditorialContent.vue?vue&type=script&lang=js&"
export * from "./PopinEditorialContent.vue?vue&type=script&lang=js&"
import style0 from "./PopinEditorialContent.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports